export default "__VITE_ASSET__e8r9pPCB__"